var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5666 14.6485V10.4551H14.9735V14.6483L10.8502 14.6479L10.85 16.2695L14.9735 16.2699V20.4612H16.5666V16.2701L20.6884 16.2705L20.6885 14.6489L16.5666 14.6485Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.7266 6.04057C10.5939 6.04057 6.43308 10.2757 6.43308 15.5C6.43308 20.7243 10.5939 24.9595 15.7266 24.9595C20.8592 24.9595 25.0201 20.7243 25.0201 15.5C25.0201 10.2757 20.8592 6.04057 15.7266 6.04057ZM4.83991 15.5C4.83991 9.38011 9.71404 4.41895 15.7266 4.41895C21.7391 4.41895 26.6133 9.38011 26.6133 15.5C26.6133 21.6199 21.7391 26.5811 15.7266 26.5811C9.71404 26.5811 4.83991 21.6199 4.83991 15.5Z",
  fill: "black"
});

function SvgCircledAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledAdd);
export default __webpack_public_path__ + "static/media/circledAdd.497761f3.svg";
export { ForwardRef as ReactComponent };